var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"simplified-header"},[_c('base-container',[_c('base-link',{staticClass:"nav-link",attrs:{"to":"homepage"}},[_c('base-svg',{staticClass:"navbar-logo",attrs:{"name":"nimphy_logo"}})],1),(_vm.$app.page.showCheckoutProgressBar)?_c('progress-bar'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }